import { useEffect, useCallback } from 'react';
import { selectors, getAll, addItem, updateItem, deleteItem } from '../../../redux/companyTaxNexus';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

export default function useCompanyTaxNexus() {
    const dispatch = useDispatch();
    const reduxState = useSelector(state => state.companyTaxNexus);
    const items = selectors.selectAll(reduxState);
    const loading = reduxState.loading;

    useEffect(() => {
        dispatch(getAll());
    }, [dispatch]);

    const save = useCallback((item) => {
        const updateCall = async () => {
            let result;
            if (item.tax_id) {
                result = await dispatch(updateItem({ id: item.tax_nexus_id, ...item }));
            } else {
                result = await dispatch(addItem(item));
            }

            if (result === false) {
                toast.error('Unable to add');
            } else {
                toast.success("Saved successfully");
            }
        };

        updateCall();
    }, [dispatch]);

    const remove = useCallback((item) => {
        const deleteCall = async () => {
            await dispatch(deleteItem(item));
            toast.success("Deleted successfully");
        };

        deleteCall();
    }, [dispatch]);

    return [
        items,
        loading,
        save,
        remove
    ];
};
